import Rank1 from '@/assets/icons/rank-1.svg?react'
import Rank2 from '@/assets/icons/rank-2.svg?react'
import Rank3 from '@/assets/icons/rank-3.svg?react'
import styles from '@/features/devices/components/DevicesList/DevicesTable.module.css'
import { OverlayScrollBars } from '@/ui-kit/components/OverlayScrollbars'
import { formatNumber } from '@/utils'
import { useLingui } from '@lingui/react/macro'
import { clsx } from 'clsx'
import type { LeaderboardEntry } from '../api/models'

type LeaderboardTableProps = {
  entries: LeaderboardEntry[]
  highlightUserId?: string | null
}

const RANK_ICONS: Record<number, React.ReactNode> = {
  1: <Rank1 />,
  2: <Rank2 />,
  3: <Rank3 />
}

export const LeaderboardTable = ({ entries, highlightUserId }: LeaderboardTableProps) => {
  const { t } = useLingui()

  const columns: { key: keyof LeaderboardEntry | 'rank'; label: string; cellClassName?: string }[] = [
    { key: 'rank', label: t`Rank` },
    { key: 'id', label: t`User` },
    { key: 'points', label: t`Points`, cellClassName: 'text-end! !pr-6' }
  ]

  return (
    <OverlayScrollBars>
      <table className={clsx(styles.table, 'max-mobile:mt-1 table w-full min-w-[500px] table-auto')}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={clsx(
                  styles.th,
                  column.cellClassName,
                  'text-default text-gray-90 border-b-0! whitespace-nowrap'
                )}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="pt-5">
          {entries.map((entry) => {
            const isHighlighted = !!highlightUserId && entry.id === highlightUserId
            return (
              <tr key={entry.id} className={clsx(styles.row, isHighlighted && styles.active)}>
                <td className={clsx(styles.cell, 'w-[150px]')}>
                  <div className="w-[60px] text-center!">
                    {entry.rank < 4 ? RANK_ICONS[entry.rank as keyof typeof RANK_ICONS] : entry.rank}
                  </div>
                </td>
                <td className={clsx(styles.cell)}>{entry.id || '-'}</td>
                <td className={clsx(styles.cell, '!pr-6 text-end')}>
                  {formatNumber(Math.round(entry.points || 0), 0)}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </OverlayScrollBars>
  )
}
